// регестрируем компоненты глобально
/* global Vue */

import alertDialog from 'components/alert-dialog'
import modalDialog from 'components/modal-dialog'
import search      from 'components/search-form/component'
import advance     from 'components/advance-info/component'
import billList    from 'components/bill-list/component'
import billInfo    from 'components/bill-info/component'
import zayavkiList     from 'components/zayavki-list/component'
import autoImportList     from 'components/auto-import-list/component'
import autoImport     from 'components/auto-import/component'
import trainInWay     from 'components/train-in-way/component'
import trainInWayInfo     from 'components/train-in-way-info/component'
import cntList     from 'components/cnt-list/component'
import cntInfo     from 'components/cnt-info/component'
import cntPoezd     from 'components/cnt-poezd/component'
import autoCarrierList     from 'components/auto-carrier-list/component'
import autoCarrierExpList     from 'components/auto-carrier-exp-list/component'
import autoExportPoezd     from 'components/auto-export-poezd/component'
import autoExportCnt     from 'components/auto-export-cnt/component'
import stationsList     from 'components/stations-list/component'
import destinationsList     from 'components/destinations-list/component'
import slotsAuto     from 'components/slots-auto/component'
import AutoList     from 'components/auto-list/component'
import KonosFilesList     from 'components/konos-files-list/component'
import KonosFile     from 'components/konos-file/component'


Vue.component('alert', alertDialog)
Vue.component('modal-dialog', modalDialog)
Vue.component('search-form', search)
Vue.component('advance-info', advance)
Vue.component('bill-list', billList)
Vue.component('bill-info', billInfo)
Vue.component('cnt-list', cntList)
Vue.component('zayavki-list', zayavkiList)
Vue.component('auto-import-list', autoImportList)
Vue.component('auto-import', autoImport)
Vue.component('train-in-way', trainInWay)
Vue.component('train-in-way-info', trainInWayInfo)
Vue.component('cnt-info', cntInfo)
Vue.component('cnt-poezd', cntPoezd)
Vue.component('auto-carrier-list', autoCarrierList)
Vue.component('auto-carrier-exp-list', autoCarrierExpList)
Vue.component('auto-export-poezd', autoExportPoezd)
Vue.component('auto-export-cnt', autoExportCnt)
Vue.component('stations-list', stationsList)
Vue.component('destinations-list', stationsList)
Vue.component('slots-auto', slotsAuto)
Vue.component('auto-list', AutoList)
Vue.component('konos-files-list', KonosFilesList)
Vue.component('konos-file', KonosFile)



/** WEBPACK FOOTER **
 ** ./src/js/lib/components.js
 **/